module.exports = __webpack_public_path__ + "img/傍晚升起的太阳.3706a9d2.jpg";